import { apiClient } from "features/shared/api/axiosInstance";
import type { ApproverDto } from "common/models/api/models/ApproverDto";
import type { CreateApproverDto } from "common/models/api/models/CreateApproverDto";
import type { ExecuteReleaseStrategyDto } from "common/models/api/models/ExecuteReleaseStrategyDto";
import type { PaginatedApproverDto } from "common/models/api/models/PaginatedApproverDto";
import type { PaginatedReleaseStrategyDto } from "common/models/api/models/PaginatedReleaseStrategyDto";
import type { ResponseReleaseStrategyExecuteDto } from "common/models/api/models/ResponseReleaseStrategyExecuteDto";
import type { RoleTypeOperationTypeDto } from "common/models/api/models/RoleTypeOperationTypeDto";
import type { UpdateApproverDto } from "common/models/api/models/UpdateApproverDto";

export const releaseStrategyApi = {
    findAll: (params?: {
        page?: number;
        pageSize?: number;
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        organizationAddress?: string;
    }) => apiClient.get<PaginatedReleaseStrategyDto>("/api/release-strategy", { params }),

    findAllApprovers: (params?: { page?: number; pageSize?: number; query?: string }) =>
        apiClient.get<PaginatedApproverDto>("/api/release-strategy/approver", { params }),

    createApprover: (body: CreateApproverDto) => apiClient.post<ApproverDto>("/api/release-strategy/approver", body),

    updateApprover: (id: number, body: UpdateApproverDto) => apiClient.patch<ApproverDto>(`/api/release-strategy/approver/${id}`, body),

    findAllOperationTypes: () => apiClient.get<RoleTypeOperationTypeDto[]>("/api/release-strategy/operation-type"),

    updateOperationTypes: (body: RoleTypeOperationTypeDto[]) => apiClient.patch("/api/release-strategy/operation-type", body),

    execute: (body: ExecuteReleaseStrategyDto) => {
        if (body.file) {
            const formData = new FormData();
            formData.append("roleType", body.roleType);
            formData.append("operationTypeId", String(body.operationTypeId));
            formData.append("userId", String(body.userId));
            if (body.programAddress) formData.append("programAddress", body.programAddress);
            formData.append("file", body.file);
            return apiClient.post<ResponseReleaseStrategyExecuteDto>("/api/release-strategy/execute", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        }
        return apiClient.post<ResponseReleaseStrategyExecuteDto>("/api/release-strategy/execute", body);
    },
};
